<div class="middle-box text-center loginscreen  animated fadeInDown">
    <div><h2 style="text-align: 'center'">RAF Electric</h2></div>
    <!-- <form #f="ngForm" (ngSubmit)="login()"> -->
    <form (submit)="login()">
        <dx-form [(formData)]="model" [showColonAfterLabel]="false" validationGroup="loginData" showValidationSummary="true" [showRequiredMark]="false">
            <dxi-item itemType="group">
                <dxi-item dataField="userName"> <dxi-validation-rule type="required" message="User name is required"></dxi-validation-rule> </dxi-item>
                <dxi-item dataField="password" [editorOptions]="{ mode: 'password' }">
                    <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                </dxi-item>
            </dxi-item>
        </dx-form>
        <dx-button text="Login" type="default" class="m-3" validationGroup="loginData" [useSubmitBehavior]="true"></dx-button>
    </form>
</div>
